// JEA Client Config

import { isDev, isLocal } from "../env";
import template from "./_template";

const PHONE_NUMBERS = [
  { label: "(904) 665-6000", value: "9046656000" },
  { label: "(904) 665-7500", value: "9046657500" },
  { label: "(904) 665-6250", value: "9046656250" },
  { label: "(904) 665-4410", value: "9046654410" },
];

if (isDev()) {
  PHONE_NUMBERS.unshift(
    { label: "(904) 665-6405", value: "9046656405" },
    { label: "(904) 665-6406", value: "9046656406" }
  );
}

const jea_config = {
  name: "jea",
  defaults: {
    device_type_vch: "voice",
  },
  disabled_features: {
    ...template.disabled_features,
    // Only using Ad Hoc EONS for Voice & SMS
    //email: false,         //JEA-564 Enabled EMAIL on 2022-09-22
  },
  enabled_features: {
    ...template.enabled_features,
    sso_microsoft_saml: true, // Whether Login page should display the Microsoft SSO button
    campaign_tag: true,
    offline_approval: false,
  },
  sms: {
    // JEA-437 Enabled SMS and added short codes
    short_codes: [
      { value: "665600", label: "665600 General" }, // REST JEA-437
    ],
  },
  voice: {
    caller_id_options: [{ label: "Select a phone number", isDisabled: true }, ...PHONE_NUMBERS],
  },
};
if (isDev() || isLocal()) {
  jea_config.enabled_features.offline_approval = true;
}
export default jea_config;
